export default "__VITE_ASSET__LXc9rQsU__"